'use strict';

var $ = require('jquery');
var ajax = require('../utils/ajax');
var util = require('../utils/util');
var validator = require('../utils/validator');

var existingFlyins = [];
var allClosed = null;
var startClass = 'ocd-animation-started';

var findInsiders = function (elem) {
    var tabbable = elem.find('select, input, textarea, button, a, [role="button"]');

    if (tabbable.length === 0) {
        elem.on('keydown', function (e) {
            if (e.which === 9) {
                e.preventDefault();
            }
        });
    } else {
        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        /*set focus on first input*/
        firstTabbable.focus();

        /*redirect last tab to first input*/
        lastTabbable.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstTabbable.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
    }
};

module.exports = {
    loadContainers: function (flyinContainer, overlayContainer) {
        var $flyinContainer = flyinContainer != null ? flyinContainer : $('footer');
        var $overlayContainer = overlayContainer != null ? overlayContainer : $('#main');

        $flyinContainer.append($('<div class="ocd-flyin"></div>'));
        $overlayContainer.append($('<div class="ocd-overlay"></div>'));
    },

    removeDefaultContainers: function () {
        $('.ocd-flyin').remove();
        $('.ocd-overlay').remove();
    },

    /**
     * Initializes a off canvas dialog.
     *
     * @param triggerClass - element class that should open or close the dialog
     * @param options - configuration object to override the defaults (detailed information below)
     * @param callback - JavaScript function that will be called after the content is loaded
     * @param content - jQuery element for local content or null if element has an href attribute
     *
     * @returns dialog object that for to control it via JavaScrcipt
     *
     * Full options example:
     * - headerStyle: behind | over
     * - contentStyle: smashed | pushed | overlaid
     * - position: left | right
     * - overlay: true | false | {
     *       backgroundColor: '#fff',
     *       backgroundOpacity: 0..1
     *   }
     * - closeOnClick: true | false,
     * - clsoeOnEsc: true | false,
     * - closeOnX: true | false,
     * - layoutSideButton: false | true
     * - hideOriginalSideButton: true | false
     * - preventScroll: false | true
     * - additionalClass: 'additional-style-class'
     * - reloadContentAlways: true | false
     * - disableMobileAnimation: false | true
     *
     * Callback Arguments:
     * - $triggerButton - the button that was used to open the dialog
     * - $flyinContainer - the container element of the dialog (including the loaded content)
     *
     * The `this` context is the dialog object (same as return value) so you can use this.hide(),
     * etc. in the callback function.
     */
    init: function (triggerClass, options, callback, content) {
        var flyinObject = {
            // defaults
            displayOptions: {
                headerStyle: 'behind',
                contentStyle: 'overlaid',
                position: document.documentElement.lang === 'ar' ? 'left' : 'right',
                overlay: false,
                closeOnClick: true,
                closeOnEsc: true,
                closeOnX: true,
                layoutSideButton: false,
                hideOriginalSideButton: true,
                preventScroll: true,
                reloadContentAlways: false,
                disableMobileAnimation: false,
                additionalClass: ''
            },
            callback: undefined,
            triggerClass: undefined,
            $lastTrigger: undefined,
            $content: undefined,
            openStatus: false,

            // global elements
            $html: $('html'),
            $bodyVar: $('body'),
            $wrapper: $('#wrapper'),
            $header: $('header'),
            $overlay: $('.ocd-overlay'),
            $flyin: $('.ocd-flyin'),

            // classes cache
            overlayClasses: '',
            flyinClasses: '',
            wrapperClasses: '',
            headerClasses: '',
            beforeShow: undefined,

            init: function (triggerClass, options, callback, content) {
                var _this = this;

                // override the defaults
                _this.setOptions(options);
                _this.setCallback(callback);
                _this.triggerClass = triggerClass;

                if (triggerClass) {
                    $('body').off('click keypress', '.' + triggerClass);
                    $('body').on('click keypress', '.' + triggerClass, function (event) {
                        if (util.isClickOrSpaceOrEnter(event)) {
                            var $trigger = $(event.target);
                            event.preventDefault();
                            _this.$lastTrigger = $trigger;

                            $.when(allClosed).done(function () {
                                var $clickTarget = $(event.target);
                                var loadContentUrl =
                                    $clickTarget.closest('[href]').attr('href') ||
                                    $clickTarget.closest('[data-href]').data('href');

                                _this.loadContent(content || loadContentUrl, function () {
                                    _this.show();
                                    findInsiders($(_this.$flyin));
                                    validator.initInContainer(_this.$flyin);
                                    if (typeof callback === 'function') {
                                        callback.call(_this, $clickTarget, _this.$flyin);
                                    }
                                });
                            });
                        }
                    });

                    this.$flyin.trigger(triggerClass, this);
                }

                return _this;
            },

            show: function () {
                var _this = this;

                if (typeof this.displayOptions.beforeShow === 'function') {
                    this.displayOptions.beforeShow.call(this, this.$flyin);
                }

                $('.closecountrydialog.close').trigger('click');
                this.$flyin.trigger('opening', this);

                if (this.displayOptions.preventScroll) {
                    this.$html.addClass('ocd-prevent-scroll');
                }

                $('.ocd-overlay').addClass(this.overlayClasses);
                this.$flyin.removeClass('left-not-active right-not-active');
                this.$wrapper.removeClass('ocd-not-active');
                this.$bodyVar.addClass('ocd-body-active');

                // Prevent site jump when press TAB on Safari (BSDDEV-1363)
                var ua = navigator.userAgent.toLowerCase();
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Not for Chrome
                    } else {
                        $(document).keydown(function (e) {
                            var keycode1 = e.keyCode ? e.keyCode : e.which;
                            if (keycode1 == 0 || keycode1 == 9) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        });
                    }
                }

                // Avoid drag effect bug on FF
                $(document).on('dragstart', function () {
                    return false;
                });

                if (this.displayOptions.overlay && typeof this.displayOptions.overlay === 'object') {
                    if (this.displayOptions.overlay.backgroundColor) {
                        this.$overlay.css('background-color', this.displayOptions.overlay.backgroundColor);
                    }

                    if (this.displayOptions.overlay.backgroundOpacity) {
                        this.$overlay.css('opacity', this.displayOptions.overlay.backgroundOpacity);
                    }
                }

                this.$wrapper.addClass(this.wrapperClasses);
                this.$header.addClass(this.headerClasses);

                // ADA: Set aria-hidden to true on each section that is visually below the flyin overlay.
                // Since the flyin is open, the user shouldn't be able to interact with these sections.
                $('.main-wrapper').attr('aria-hidden', 'true');
                $('.footer > .hide-on-desktop').attr('aria-hidden', 'true');
                $('.footer-payment-and-delivery').attr('aria-hidden', 'true');
                $('.footer-navigation').attr('aria-hidden', 'true');
                $('.footer-copyright-container').attr('aria-hidden', 'true');
                $('.footer > .content-asset').attr('aria-hidden', 'true');

                // close on click
                $(document).on(
                    util.isMobile() ? 'touchend' : 'mouseup',
                    function (event) {
                        var $clickTarget = $(event.target);
                        var touchCloseByX = false;

                        if (this.displayOptions.closeOnClick) {
                            touchCloseByX =
                                util.isMobile() &&
                                event.originalEvent.changedTouches.length &&
                                $('.ocd-content').position().left > event.originalEvent.changedTouches[0].pageX;

                            if (
                                !$clickTarget.hasClass(this.triggerClass) &&
                                (($clickTarget.closest('.ocd-content').length === 0 &&
                                    !$clickTarget.hasClass('ocd-content')) ||
                                    touchCloseByX)
                            ) {
                                this.hide();

                                if (touchCloseByX) {
                                    event.preventDefault();
                                }
                            }
                        }
                    }.bind(this)
                );

                // close on ESC
                $(document).on(
                    'keydown',
                    function (event) {
                        if (this.displayOptions.closeOnEsc) {
                            if (event.keyCode == 27) {
                                this.hide();
                                $(`a.${this.triggerClass}, [role=link].${this.triggerClass}`)[0].focus({
                                    focusVisible: true,
                                    preventScroll: true
                                });
                            }
                        }
                    }.bind(this)
                );

                // show initialized flyIn
                this.$flyin.addClass(this.flyinClasses);
                this.startAnimation('show', null, function () {
                    _this.$flyin.trigger('opened', _this);
                });
                this.openStatus = true;
                allClosed = $.Deferred();
            },

            hide: function () {
                var _this = this;

                $('a.' + _this.triggerClass).attr('aria-expanded', 'false');

                if (_this.displayOptions.preventScroll) {
                    _this.$html.removeClass('ocd-prevent-scroll');
                }

                if (_this.openStatus) {
                    _this.$flyin.addClass(this.displayOptions.position + '-not-active');

                    _this.startAnimation(
                        'hide',
                        function () {
                            _this.$flyin.trigger('hide', _this);
                            _this.$wrapper.addClass('ocd-not-active');
                            _this.$bodyVar.removeClass('ocd-body-active');

                            if (_this.displayOptions.overlay) {
                                _this.$overlay.addClass('fade-out');
                            }
                            $('.ocd-overlay').removeClass('active right');
                        },
                        function () {
                            _this.$flyin.empty();
                            _this.$flyin = $('.ocd-flyin');
                            _this.$flyin.removeClass('m-add_gap');

                            if (_this.displayOptions.layoutSideButton) {
                                _this.displayOptions.layoutSideButton.css('display', '');
                            }

                            if (_this.displayOptions.overlay && typeof _this.displayOptions.overlay === 'object') {
                                _this.$overlay.removeAttr('style');
                            }

                            _this.$overlay.removeClass(_this.overlayClasses + ' fade-out');
                            _this.$flyin.removeClass(_this.flyinClasses);
                            _this.$wrapper.removeClass(_this.wrapperClasses);
                            _this.$header.removeClass(_this.headerClasses);
                            _this.$flyin.removeAttr('style');

                            $(document).unbind('mouseup');
                            $(document).unbind('touchend');
                            $(document).unbind('keydown');

                            _this.openStatus = false;
                            if (allClosed) {
                                allClosed.resolve();
                            }
                            _this.$flyin.trigger('hidden', _this);

                            // ADA: Set aria-hidden to false on each section that was visually below the flyin overlay.
                            // Once the flyin is closed, the user should again be able to interact with these sections.
                            $('.main-wrapper').attr('aria-hidden', 'false');
                            $('.footer > .hide-on-desktop').attr('aria-hidden', 'false');
                            $('.footer-payment-and-delivery').attr('aria-hidden', 'false');
                            $('.footer-navigation').attr('aria-hidden', 'false');
                            $('.footer-copyright-container').attr('aria-hidden', 'false');
                            $('.footer > .content-asset').attr('aria-hidden', 'false');
                        }
                    );
                }
            },

            startAnimation: function (animationType, startCallback, completeCallback) {
                var $body = $('body');
                var width = this.$flyin.width();
                var position = this.displayOptions.position;
                var flyinTo = 0;
                var flyinFrom = 0;
                var animationDuration = this.displayOptions.disableMobileAnimation && util.isMobile() ? 0 : 400;

                $body.addClass(startClass);

                if (typeof startCallback === 'function') {
                    startCallback();
                }

                if (animationType === 'show') {
                    this.$flyin.css(position, -width);
                    flyinTo = (position === 'right' ? -1 : 1) * width;
                } else {
                    flyinFrom = (position === 'right' ? -1 : 1) * width;
                }

                let afterAnimation = () => {
                    $body.removeClass(startClass);
                    completeCallback();
                };

                setTimeout(afterAnimation, 200);
            },

            loadContent: function (element, callback) {
                if (!this.$content || this.displayOptions.reloadContentAlways) {
                    if (typeof element === 'object') {
                        if (element.html) {
                            this.$content = typeof element.html === 'function' ? element.html() : element.html;
                        }
                        this.renderContent(callback);
                    } else if (typeof element === 'string') {
                        ajax.load({
                            url: element,
                            callback: function (response) {
                                this.$content = response;
                                this.renderContent(callback);
                            }.bind(this)
                        });
                    }
                } else {
                    this.renderContent(callback);
                }
            },

            renderContent: function (callback) {
                this.$flyin.empty();

                const $contentContainer = $(
                    '<div class="ocd-content" role="menu" aria-label="Flyout menu" aria-modal="true" tabindex="-1"></div>'
                );

                const closeClass = this.displayOptions.closeIconClass || 'icon-close';
                const $closeIcon = $(
                    `<div class="ocd-close link-1774" tabindex="0" aria-label="` +
                        Resources.CLOSE +
                        `" role="button"><i class="icon ${closeClass}" aria-hidden="true" tabindex="-1"></i></div>`
                );

                this.$flyin.append(this.getSideButton());
                this.$flyin.append($contentContainer.html(this.$content));

                if (this.displayOptions.closeOnX) {
                    $contentContainer.append($closeIcon);

                    $closeIcon.on(
                        'click',
                        function (event) {
                            event.preventDefault();

                            // BSDDEV-2187: support multiple triggers per page
                            if (this.$lastTrigger && this.$lastTrigger.length) {
                                this.$lastTrigger.focus();
                                this.$lastTrigger = undefined;
                            } else {
                                $('a.' + this.triggerClass).focus();
                                $('.' + this.triggerClass).focus();
                            }
                            this.hide();
                        }.bind(this)
                    );
                    $closeIcon.keypress(function (event) {
                        if (event.keyCode === 13) {
                            $closeIcon.click();
                        }
                    });
                }

                this.$flyin = $('.ocd-flyin');
                $('.ocd-content').focus();

                callback();
            },

            getSideButton: function () {
                var $sideButtonContainer = $('<div class="ocd-side-button"></div>');
                var $sideButton = this.displayOptions.layoutSideButton;
                var $sideButtonClone;

                if ($sideButton) {
                    $sideButtonClone = $sideButton.clone();
                    $sideButtonClone.removeClass(triggerClass);
                    $sideButtonClone.find('.' + this.triggerClass).removeClass(this.triggerClass);

                    $sideButtonClone.on(
                        'click',
                        function (event) {
                            event.preventDefault();
                            this.hide();
                        }.bind(this)
                    );

                    $sideButtonContainer.append($sideButtonClone);

                    if (this.displayOptions.hideOriginalSideButton) {
                        var style = $sideButton.attr('style');
                        style = (style !== '' ? style + ';' : '') + 'display:none!important;';
                        $sideButton.attr('style', style);
                    }
                }

                return $sideButtonContainer;
            },

            setOptions: function (options) {
                if (options) {
                    this.displayOptions = $.extend({}, this.displayOptions, options);
                }

                this.overlayClasses = this._getOverlayClasses();
                this.flyinClasses = this._getFlyinClasses();
                this.wrapperClasses = this._getWrapperClasses();
                this.headerClasses = this._getHeaderClasses();
            },

            setCallback: function (callback) {
                if (callback) {
                    this.callback = callback;
                }
            },

            isOpened: function () {
                return this.openStatus;
            },

            _getWrapperClasses: function () {
                var wrapperClasses = [
                    'ocd-active',
                    'ocd-' + this.displayOptions.position,
                    'ocd-' + this.displayOptions.contentStyle
                ];

                if (this.displayOptions.additionalClass) {
                    wrapperClasses.push(this.displayOptions.additionalClass);
                }

                if (this.displayOptions.layoutSideButton) {
                    wrapperClasses.push('ocd-with-button');
                }

                return wrapperClasses.join(' ');
            },

            _getFlyinClasses: function () {
                var flyinClasses = ['active', this.displayOptions.position];

                if (this.displayOptions.headerStyle === 'behind') {
                    flyinClasses.push('behind-header');
                }

                if (this.displayOptions.additionalClass) {
                    flyinClasses.push(this.displayOptions.additionalClass);
                }

                if (this.displayOptions.layoutSideButton) {
                    flyinClasses.push('with-button');
                }

                return flyinClasses.join(' ');
            },

            _getHeaderClasses: function () {
                var headerClasses = [];

                if (this.displayOptions.headerStyle === 'over') {
                    headerClasses.push('ocd-active');
                    headerClasses.push('ocd-' + this.displayOptions.position);
                }

                return headerClasses.join(' ');
            },

            _getOverlayClasses: function () {
                var overlayClasses = [];

                if (this.displayOptions.overlay) {
                    overlayClasses.push('active');
                    overlayClasses.push(this.displayOptions.position);
                }

                return overlayClasses.join(' ');
            }
        };

        if (Array.isArray(triggerClass)) {
            triggerClass = triggerClass.join(', .');
        }

        flyinObject.init(triggerClass, options, callback, content);
        existingFlyins.push(flyinObject);

        return flyinObject;
    },

    closeAll: function () {
        $.each(existingFlyins, function (_, flyin) {
            if (flyin.isOpened()) {
                flyin.hide();
            }
        });
    }
};
